import styled from 'styled-components';

export const LogoWrapper = styled.div`
  float: left;
  margin-left: -60px;
  margin-right: 30px;
`;
